import { Card, Flex, Typography } from "antd";
import React from "react";

export default function ProcedureRowItem({ index, procedure, itemCount, itemCountDescription }) {
  function identifyColor(index) {
    switch (index) {
      case 1:
        return "#6B43B5";
      case 2:
        return "#9176DC";
      case 3:
        return "#AD9EE7";
      case 4:
        return "#E0DDF7";
      default:
        return "#E0DDF7";
    }
  }

  return (
    <Card size="small" style={{ padding: 3 }}>
      <Flex align="center" justify="space-between">
        <Flex align="center" gap={10}>
          <Flex
            style={{
              width: 24,
              height: 24,
              backgroundColor: identifyColor(index + 1),
              color: index + 1 > 3 ? "#6B43B5" : "white",
              borderRadius: 100,
            }}
            align="center"
            justify="center"
          >
            {index + 1}
          </Flex>
          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            {procedure.procedureCode} - {procedure.procedureDescription}
          </Typography.Title>
        </Flex>

        <Typography.Paragraph style={{ marginBottom: 0, color: "#6B43B5" }}>
          {itemCount} {itemCountDescription}
        </Typography.Paragraph>
      </Flex>
    </Card>
  );
}
